module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "app-aside",
    class: _vm.hide_menu
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMenu),
      expression: "showMenu"
    }, {
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "tree-menu"
  }, [_c('div', {
    staticClass: "titleBar"
  }, [_vm._v("项目监管系统")]), _vm._v(" "), _c('l-tree', {
    attrs: {
      "treedata": _vm.treedata,
      "currentNodeName": _vm.currentNodeName
    },
    nativeOn: {
      "click": function($event) {
        _vm.toggle($event)
      }
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4ba81642","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/app_aside.vue
// module id = 588
// module chunks = 143